export default {"src":"/_next/static/media/sesame.3da88022.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};